import {
    useLayoutEffect,
    useEffect,
    useState
} from "react";
import {
    ActivityIndicator,
    FlatList,
    TouchableOpacity,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import AnnouncementsCard from "./components/announcementCard";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    PageContainer,
    Text
} from "ncore-ui-kit";
import {
    useNavigation
} from "@react-navigation/native";
import {
    useSafeAreaInsets
} from "react-native-safe-area-context";
import type {
    AnnouncementData,
    GetAnnouncementsResquestType
} from "../../../services/restAPI/actions/getAnnouncements/types";
import type AppStackParamList from "../../../types/navigation/app";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import {
    ChevronLeft,
} from "lucide-react-native";
import {
    RESTService
} from "../../../services/restAPI";
import {
    storage
} from "../../../storage";

const Announcements = () => {
    const navigation = useNavigation<NativeStackNavigationProp<AppStackParamList>>();

    const {
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [loading,
        setLoading] = useState(true);
    const [data,
        setData] = useState<AnnouncementData[]>([]);
    const [page,
        setPage] = useState(1);
    const [endReached,
        setEndReached] = useState(false);
    const [searchLoading,
        setSearchLoading] = useState(false);

    const inset = useSafeAreaInsets();

    useEffect(() => {
        getAnnouncementsData();
    }, []);

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: true,
            header: () => renderHeader()
        });
    }, [
        navigation
    ]);

    const getAnnouncementsData = (_page?: number) => {
        if(!searchLoading) setSearchLoading(true);

        const params: GetAnnouncementsResquestType = {
            language: storage.getString("language") ?? "tr-TR"
        };

        if(_page) {
            params.page = _page;
        }

        RESTService.action("GetAnnouncements", params)
            .then((res) => {
                if(res.code === 200 || res.code === 201 || res.code === 202) {
                    if(_page) {
                        setPage(_page);
                        const _data = JSON.parse(JSON.stringify(data));
                        const _newData = res.payload.filter(newItem => !_data.some((oldItem: { _id: string }) => oldItem._id === newItem._id));
                        setData([
                            ..._data,
                            ..._newData
                        ]);

                        if(res.payload.length < 9) {
                            setEndReached(true);
                        }

                    } else {
                        setData(res.payload);
                    }

                    if(res.payload.length < 9) {
                        setEndReached(true);
                    }
                    setSearchLoading(false);
                    setLoading(false);
                }

                setSearchLoading(false);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setLoading(false);
            });
    };

    const renderHeader = () => {
        return <View
            style={[
                stylesheet.headerWrapper,
                {
                    paddingTop: inset.top + spaces.spacingMd,
                    paddingBottom: spaces.spacingMd,
                    paddingHorizontal: spaces.spacingMd,
                    backgroundColor: colors.content.container.default
                }
            ]}
        >
            <TouchableOpacity
                style={[
                    stylesheet.backButton,
                    {
                        padding: spaces.spacingSm
                    }
                ]}
                onPress={() => {
                    navigation.goBack();
                }}
            >
                <ChevronLeft
                    size={30}
                />
            </TouchableOpacity>
            <View
                style={[
                    stylesheet.headerTitleContainer,
                    {
                        top: inset.top + spaces.spacingSm
                    }
                ]}
            >
                <Text
                    variant="titleLargeSize"
                    color="high"
                    style={stylesheet.headerTitle}
                >
                    {localize("announcements")}
                </Text>
            </View>
        </View>;
    };
    const renderNotFound = () => {
        return <View
            style={stylesheet.notFoundContainer}
        >
            <Text
                variant="headlineLargeSize"
                style={stylesheet.textCenter}
            >
                {localize("not-found")}
            </Text>
        </View>;
    };

    if(loading) {
        return <PageContainer
            style={stylesheet.loadingContainer}
        >
            <ActivityIndicator
                size={40}
                color={colors.content.icon.default}
            />
        </PageContainer>;
    }

    return <PageContainer
        isScrollable={false}
    >
        <FlatList
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            keyExtractor={(item) => item._id}
            onEndReachedThreshold={0.7}
            onEndReached={() => {
                if(endReached) {
                    return;
                }
                if(searchLoading) {
                    return;
                }
                getAnnouncementsData(page + 1);
            }}
            renderItem={({
                item
            }) => {
                return <AnnouncementsCard
                    coverPhotoURL={item.coverPhotoURL}
                    description={item.shortContent}
                    onPress={() => {
                        navigation.navigate("AnnouncementDetail", {
                            announcementID: item._id
                        });
                    }}
                    title={item.title}
                />;
            }}
            horizontal={false}
            style={{
                marginBottom: spaces.spacingXl * 3
            }}
            data={data}
            ListEmptyComponent={renderNotFound}
        />
    </PageContainer>;
};
export default Announcements;
